<template>
  <div class="portfolio-case-study container" id="trofi">
    <CsVideoIntro v-bind="project.caseStudy.intro"></CsVideoIntro>
    <CsSynopsis v-bind="project.caseStudy.synopsis"></CsSynopsis>
    <CsShowcase v-bind="project.caseStudy.showcase"></CsShowcase>
    <CsImageGrid
      @loaded="mountTrigger"
      v-bind="project.caseStudy.imageGrid"
    ></CsImageGrid>

    <!-- <div class="cs-project-credits">
			<div class="cs-project-credits-content">
				<h3>Project Credits & Details</h3>
				<ul>
					<li>
						<span>Associated Agency</span>
						<span>Architecto omnis quibusdam ab corrupti quam</span>
					</li>
					<li>
						<span>Assistant Jr. Developer</span>
						<span>Nelson Khiev</span>
					</li>
					<li>
						<span>Assistant Jr. Developer</span>
						<span>Nelson Khiev</span>
					</li>
					<li>
						<span>Assistant Jr. Developer</span>
						<span>Nelson Khiev</span>
					</li>
				</ul>
			</div>
		</div> -->
    <CallToAction v-if="mountReady" v-bind="cta" />
  </div>
</template>

<script>
import { heeman, cta } from "@/data/projects.js";
import CallToAction from "@/components/CallToAction";
import CsVideoIntro from "@/components/CsVideoIntro/CsVideoIntro";
import CsSynopsis from "@/components/CsSynopsis/CsSynopsis";
import CsShowcase from "@/components/CsShowcase/CsShowcase";
import CsImageGrid from "@/components/CsImageGrid/CsImageGrid";

export default {
  name: "Heemans",
  metaInfo: {
    title: `Heeman's`,
    meta: [
      {
        name: "description",
        content: `Making the Heeman experience online just as fulfilling as in person. The Heeman website is a hub for all things Heeman, from the latest news, events, and products.`,
      },
    ],
  },
  data() {
    return {
      project: heeman,
      mountReady: false,
      cta: cta,
    };
  },
  components: {
    CallToAction,
    CsVideoIntro,
    CsSynopsis,
    CsShowcase,
    CsImageGrid,
  },
  methods: {
    mountTrigger(val) {
      this.mountReady = val;
    },
  },
};
</script>
